import React, { useEffect, useState } from "react";
import { Logo } from "../brand/Logo";
import { FEATURES } from "@/config/features";

const NAV_LINKS = [
  { label: "Products", href: "#products", testId: "nav-link-products" },
  ...(FEATURES.showRevive
    ? [{ label: "REVIVE", href: "#revive", testId: "nav-link-revive" }]
    : []),
  { label: "Why Us", href: "#why-us", testId: "nav-link-why-us" },
  { label: "Coming Soon", href: "#coming-soon", testId: "nav-link-coming-soon" },
  { label: "Contact", href: "#contact", testId: "nav-link-contact" },
];

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navigation"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-bone/85 border-b border-hairline"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between py-4">
        <Logo variant="compact" />
        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testId}
              className="overline text-ink hover:text-terracotta transition-colors duration-300 link-underline"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#products"
          data-testid="nav-shop-cta"
          className="font-display text-sm font-semibold tracking-wide bg-ink text-bone hover:bg-terracotta hover:text-white transition-colors duration-300 px-5 py-2.5 rounded-sm"
        >
          Shop Nutrition
        </a>
      </div>
    </header>
  );
};
